<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            <!-- <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page"> Current Inventory  Management</li>
                    </ol>
                </nav>
            </div> -->
            <h4 class="page-title">Current Inventory Management</h4>
        </div>

    </div>
</div>

<div style="display: block;Width:12%;margin-left: 30px;" *ngIf="write==true">
    <div class="mt-3" >
        <a *ngIf="!show" href="javascript:void(0)" (click)="addCurrentInventory()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addCurrentInventory()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
    </div>
</div>

<div *ngIf="show">
    <div>

        <div class="container-fluid" style="margin-top: -19px;">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #currentInventory="ngForm" novalidate>
                                <div class="form-body">
                                    <h3 class="card-title">Add Current Inventory</h3>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span> Account
                                                    Id
                                                </label>
                                                <select class="form-control" required #accountId="ngModel" (change)="getByVendorStatus(currentInventoryAddObj.accountId)"
                                                    name="accountId" [(ngModel)]="currentInventoryAddObj.accountId"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                    <option disabled="" value="" selected>Account </option>

                                                    <option *ngFor="let ual of userAccountsList" value="{{ual._id}}">
                                                        {{ual.emailAddress}}</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!accountId.errors.required"
                                                    *ngIf="accountId.errors && (accountId.touched || accountId.dirty)">*Please
                                                    select Account Id
                                                </span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Product
                                                    Name </label>
                                                <input type="text" id="productName" class="form-control" required
                                                    minlength="3" maxlength="30" #productName="ngModel"
                                                    name="productName" [(ngModel)]="currentInventoryAddObj.productName"
                                                    placeholder="Product Name"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!productName.errors.required"
                                                    *ngIf="productName.errors && (productName.touched || productName.dirty)">
                                                    *This Field is Required</span>
                                                <span class="text-danger" [hidden]="!productName.errors?.pattern"
                                                    *ngIf="productName.errors && (productName.touched || productName.dirty)">
                                                    Product Name Should Be Only Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!productName.errors?.minlength || productName.errors.pattern"
                                                    *ngIf="productName.errors && (productName.touched || productName.dirty)">Product
                                                    Name Should Be Min 3 Characters</span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <label class="control-label"> <span class="text-danger">*</span> Product Id</label>
                                    <div class="row">
                                        <div class="col-md-6 ">
                                            <div class="form-group">
                                                <input type="text" id="productUniqueNumber" required
                                                    #productUniqueNumber="ngModel" name="productUniqueNumber"
                                                    [(ngModel)]="currentInventoryAddObj.productUniqueNumber"
                                                    class="form-control" rows="4">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!productUniqueNumber.errors.required"
                                                    *ngIf="productUniqueNumber.errors && (productUniqueNumber.touched || productUniqueNumber.dirty)">
                                                    This Field is Required</span>

                                            </div>
                                        </div>
                                    </div>

                                    <label class="control-label"> <span class="text-danger">*</span> Product
                                        Description</label>
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <input type="text" id="description" required #description="ngModel"
                                                    name="description" [(ngModel)]="currentInventoryAddObj.description"
                                                    class="form-control" rows="4">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!description.errors.required"
                                                    *ngIf="description.errors && (description.touched || description.dirty)">
                                                    This Field is Required</span>

                                            </div>
                                        </div>
                                    </div>
                                    <!--/row-->
                                    <div class="row">
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Stock
                                                    Quantity
                                                </label>
                                                <input type="text" id="stockQuantity" class="form-control"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57" required
                                                    maxlength="30" #stockQuantity="ngModel" name="stockQuantity"
                                                    [(ngModel)]="currentInventoryAddObj.stockQuantity"
                                                    placeholder="stockQuantity" maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!stockQuantity.errors.required"
                                                    *ngIf="stockQuantity.errors && (stockQuantity.touched || stockQuantity.dirty)">
                                                    *This Field is Required</span>


                                            </div>
                                        </div>
                                        <!--/span-->
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Stock
                                                    Unit
                                                </label>
                                                <input type="text" id="stockUnit" class="form-control" required
                                                    minlength="3" maxlength="30" #stockUnit="ngModel" name="stockUnit"
                                                    [(ngModel)]="currentInventoryAddObj.stockUnit"
                                                    placeholder="Stock Unit"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!stockUnit.errors.required"
                                                    *ngIf="stockUnit.errors && (stockUnit.touched || stockUnit.dirty)">
                                                    *This Field is Required</span>

                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <div class="row">
                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Purchase
                                                    Date
                                                </label>
                                                <input type="date" id="purchaseDate" class="form-control" required
                                                    minlength="3" maxlength="30" #purchaseDate="ngModel"
                                                    name="purchaseDate"
                                                    [(ngModel)]="currentInventoryAddObj.purchaseDate"
                                                    placeholder="Select Date" maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!purchaseDate.errors.required"
                                                    *ngIf="purchaseDate.errors && (purchaseDate.touched || purchaseDate.dirty)">
                                                    *This Field is Required</span>

                                            </div>
                                        </div>

                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Expiry
                                                    Date
                                                </label>
                                                <input type="date" id="expiryDate" class="form-control" required
                                                    minlength="3" maxlength="30" #expiryDate="ngModel" name="expiryDate"
                                                    [min]="currentInventoryAddObj.purchaseDate | date:'yyyy-MM-dd'"
                                                    [(ngModel)]="currentInventoryAddObj.expiryDate"
                                                    placeholder="Select Date" maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!expiryDate.errors.required"
                                                    *ngIf="expiryDate.errors && (expiryDate.touched || expiryDate.dirty)">
                                                    *This Field is Required</span>

                                            </div>
                                        </div>

                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <!--/row-->
                                    <div class="row">
                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Storage
                                                    Location
                                                </label>
                                                <input type="text" id="storageLocation" class="form-control" required
                                                    minlength="3" maxlength="30" #storageLocation="ngModel"
                                                    name="storageLocation"
                                                    [(ngModel)]="currentInventoryAddObj.storageLocation"
                                                    placeholder="Storage Location" maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!storageLocation.errors.required"
                                                    *ngIf="storageLocation.errors && (storageLocation.touched || storageLocation.dirty)">
                                                    *This Field is Required</span>

                                            </div>
                                        </div>

                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label">Borrowed
                                                </label>
                                                <select class="form-control" id="borrowed"  #borrowed
                                                    data-placeholder="Choose a Yes/No" tabindex="1">
                                                    <option value="no" selected="">NO </option>

                                                    <option value="yes ">YES</option>

                                                </select>
                                               


                                            </div>
                                        </div>

                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <div class="row">
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Category Name</label>
                                                <select class="form-control"  #categoryId="ngModel"
                                                    (change)="getSubCategoryByCategoryId(currentInventoryAddObj.category)"
                                                    name="categoryId" [(ngModel)]="currentInventoryAddObj.category"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                    <option disabled="" value="" selected>Category</option>
    
                                                    <option *ngFor="let cl of categoriesList" value="{{cl.name}}">
                                                        {{cl.name}}</option>
                                                        <option value="Others" >Others</option>
                                                </select>
                                                <span class="text-danger" [hidden]="!categoryId.errors.required"
                                                    *ngIf="categoryId.errors && (categoryId.touched || categoryId.dirty)">*Please
                                                    select Category
                                                </span>
                                                <br>

                                                <input type="text" id="otherCategory" required *ngIf="showTextField"
                                                #otherCategory="ngModel" name="otherCategory" placeholder="Enter category Name"
                                                [(ngModel)]="currentInventoryAddObj.otherCategory"
                                                class="form-control" rows="4">                                            </div>
                                        </div>
                                        <!--/span-->
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Sub Category Name</label>
                                                <select class="form-control"  #subCategoryId="ngModel" (change)="checking(currentInventoryAddObj.subCategory)"
                                                    name="subCategoryId" [(ngModel)]="currentInventoryAddObj.subCategory"
                                                    data-placeholder="Choose a Sub Category" tabindex="1">
                                                    <option disabled="" value="" selected>Sub Category</option>
    
                                                    <option *ngFor="let scl of subCategoriesList" value="{{scl.name}}">
                                                        {{scl.name}}</option>
                                                        <option value="Others" >Others</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!subCategoryId.errors.required"
                                                    *ngIf="subCategoryId.errors && (subCategoryId.touched || subCategoryId.dirty)">*Please
                                                    select Sub Category
                                                </span>
                                                <br>
                                                <input type="text" id="otherSubCategory" required *ngIf="showSubTextField"
                                                #otherSubCategory="ngModel" name="otherSubCategory" placeholder="Enter Sub Category Name"
                                                [(ngModel)]="currentInventoryAddObj.otherSubCategory"
                                                class="form-control" rows="4">
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <div class="row">
                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Order ID

                                                </label>
                                                <input type="text" id="orderId" class="form-control" required
                                                    minlength="3" maxlength="30" #orderId="ngModel" name="orderId"
                                                    [(ngModel)]="currentInventoryAddObj.orderId" placeholder="Order Id"
                                                    maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!orderId.errors.required"
                                                    *ngIf="orderId.errors && (orderId.touched || orderId.dirty)">
                                                    *This Field is Required</span>

                                            </div>
                                        </div>

                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Vendor
                                                    Name
                                                </label>
                                                <select class="form-control"  #vendorId="ngModel"  required
                                                    name="vendorId" [(ngModel)]="currentInventoryAddObj.vendorId"
                                                    data-placeholder="Choose a Vendor Name" tabindex="1">
                                                    <option disabled="" value="" selected>Vendor</option>

                                                    <option *ngFor="let vl of vendorsList" value="{{vl._id}}">
                                                        {{vl.vendorName}}</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!vendorId.errors.required"
                                                    *ngIf="vendorId.errors && (vendorId.touched || vendorId.dirty)">*Please
                                                    select vendorId
                                                </span>


                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span
                                                        class="text-danger">*</span>Price</label>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon1"><i
                                                                class="ti-money"></i></span>
                                                    </div>

                                                    <input type="text" class="form-control" required #price="ngModel"
                                                        name="price" 
                                                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
                                                        [(ngModel)]="currentInventoryAddObj.price" placeholder="price"
                                                        aria-label="price" aria-describedby="basic-addon1">
                                                    <span class="text-danger" [hidden]="!price.errors.required"
                                                        *ngIf="price.errors && (price.touched || price.dirty)">*This
                                                        field is required
                                                    </span>
                                                </div>
                                            </div>
                                        </div>


                                        <!--/span-->
                                        <div class="col-md-3">
                                            <h5 class="card-title m-t-20"> <span class="text-danger">*</span>Product
                                                Image</h5>


                                            <div class="btn btn-info waves-effect waves-light">
                                                <input type="file" id="container"
                                                    accept="image/gif, image/jpeg, image/png"
                                                    (change)="fileChangeEvent($event)" required #productImage="ngModel"
                                                    name="productImage"
                                                    [(ngModel)]="currentInventoryAddObj.productImage" class="upload">
                                            </div>
                                            <span class="text-danger" [hidden]="!productImage.errors.required"
                                                *ngIf="productImage.errors && (productImage.touched || productImage.dirty)">*This
                                                Field is required
                                            </span>
                                        </div>

                                    </div>
                                    <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                        style="margin: 3px;"> <br />
                                </div>

                                <div class="form-actions m-t-40" *ngIf="export==true">
                                    <button type="submit" style="background-color: #353556;color:white" class="btn"
                                        (click)="saveCurrentInventory(borrowed)" [disabled]="!currentInventory.valid">
                                        <i class="fa fa-check"></i> Submit</button> &nbsp;&nbsp;
                                    <button type="button" class="btn btn-dark" (click)="addCurrentInventory()"
                                        data-dismiss="modal">Cancel</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>

        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
    </div>
</div>
<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">

                            <div class="row">
                                <div class="col-md-11">
                                    <div id="zero_config_filter" class="dataTables_filter" (click)="filter()">
                                        <button style="background-color: #e0e09e" >
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>
                                </div>

                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter" (click)="exportTable()">
                                        <button style="background-color: #e0e09e">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </div>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected"
                                        value="ei" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> Account Email Id &nbsp;&nbsp;
                                    <input type="radio" id="name" name="gender" [(ngModel)]="filterValueSelected"
                                        value="pn" (change)="applyCustomizedFilter()"> Prouct Name &nbsp;&nbsp;
                                    <input type="radio" id="storagelocation" name="gender"
                                        [(ngModel)]="filterValueSelected" value="sl"
                                        (change)="applyCustomizedFilter()">Storage Location&nbsp;&nbsp;
                                    <input type="radio" id="Category " name="gender" [(ngModel)]="filterValueSelected"
                                        value="c" (change)="applyCustomizedFilter()"> Category &nbsp;&nbsp;
                                    <input type="radio" id="subcategory" name="gender" [(ngModel)]="filterValueSelected"
                                        value="sc" (change)="applyCustomizedFilter()">Sub Category &nbsp;&nbsp;
                                    <input type="radio" id="orderId" name="gender" [(ngModel)]="filterValueSelected"
                                        value="oi" (change)="applyCustomizedFilter()"> Order Id &nbsp;&nbsp;
                                    <input type="radio" id="vendorId" name="gender" [(ngModel)]="filterValueSelected"
                                        value="vi" (change)="applyCustomizedFilter()"> Vendor Id &nbsp;&nbsp;


                                </div>
                                <div style="margin-left: 820px">

                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>


                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        
                                        <ng-container matColumnDef="accountEmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Email Id</th>
                                            <td *matCellDef="let row">
                                                {{row.accountEmailId}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="productName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                                            <td *matCellDef="let row">
                                                {{row.productName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="productImage">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Image</th>
                                            <td *matCellDef="let row" style="white-space: nowrap;">
                                              
                                                <button class="dropdown-item" data-toggle="modal"
                                                data-target="#responsiveImages" style="color:rgb(30, 110, 124)" (click)="viewImages(row.productId)">
                                               View
                                                </button>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="productUniqueNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Unique Number
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.productUniqueNumber}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="description">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                                            <td *matCellDef="let row">
                                                {{row.description}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="stockQuantity">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Quantity</th>
                                            <td *matCellDef="let row">
                                                {{row.stockQuantity}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="stockUnit">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Stock Unit</th>
                                            <td *matCellDef="let row">
                                                {{row.stockUnit}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="purchaseDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Date</th>
                                            <td *matCellDef="let row">
                                                {{row.purchaseDate|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="expiryDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Expiry Date</th>
                                            <td *matCellDef="let row">
                                                {{row.expiryDate|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="storageLocation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Storage Location</th>
                                            <td *matCellDef="let row">
                                                {{row.storageLocation}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="borrowed">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Borrowed/Lent/Shared
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.borrowed}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="category">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                style="padding-left: 40px;">Category</th>
                                            <td *matCellDef="let row" style="padding-left: 40px;">
                                                {{row.category}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="subCategory">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sub Category</th>
                                            <td *matCellDef="let row">
                                                {{row.subCategory}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="price">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                                            <td *matCellDef="let row">
                                                {{row.price}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="orderId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Id</th>
                                            <td *matCellDef="let row">
                                                {{row.orderId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="vendorId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Vendor Id</th>
                                            <td *matCellDef="let row">
                                                {{row.vendorId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="uploadType">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload Type</th>
                                            <td *matCellDef="let row">
                                                {{row.UploadType}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="productManuallyAddOrAutoMovedDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Manually
                                                Added Or AutoMoved Date</th>
                                            <td *matCellDef="let row">
                                                {{row.productManuallyAddOrAutoMovedDate|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="addedByUserId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Added By User Id</th>
                                            <td *matCellDef="let row">
                                                {{row.addedByUserId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Actions">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>

                                            <td *matCellDef="let row">
                                                <p *ngIf="read==true  && delete!=true && write !=true "
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    didn't have permission for actions</p>

                                                <ul class="list-group list-group-flush"
                                                    *ngIf="write==true || delete==true">
                                                    <li class="list-group-item  friend-list mb-2">

                                                        <div class="dropdown show float-right list-block">
                                                            <a class="userDropdown" href="#" role="button"
                                                                style="margin-right: 140px;" id="userDropdown"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">
                                                                <button class="dropdown-item" data-toggle="modal"
                                                                    *ngIf="write==true" data-target="#responsive"
                                                                    (click)="getByCurrentInventoryId(row._id)">
                                                                    <i class="fa fa-address-card"
                                                                        aria-hidden="true"></i>Edit</button>
                                                                        <button class="dropdown-item" data-toggle="modal"
                                                                        *ngIf="write==true" data-target="#responsiveUpdate"
                                                                        (click)="getByCurrentInventoryId(row._id)">
                                                                        <i class="fa fa-refresh"
                                                                            aria-hidden="true"></i>Update </button>
                                                                <div *ngIf="write==true">
                                                                    <button class="dropdown-item"
                                                                        (click)="deleteCurrentInventory(row._id)"
                                                                        *ngIf="delete==true">
                                                                        <i class="fa fa-trash p-2"
                                                                            aria-hidden="true"></i>Delete</button>
                                                                </div>
                                                                <mat-slide-toggle (change)="onChange($event,row._id)"
                                                                    [checked]="row.status">
                                                                    <span *ngIf="row.status==false">
                                                                        In Active</span>
                                                                    <span *ngIf="row.status==true">
                                                                        Active</span>
                                                                </mat-slide-toggle>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>



                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit Current Inventory Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #currentInventoryUpdate="ngForm" novalidate>
                    <div class="form-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span> Account
                                        Id
                                    </label>
                                    <select class="form-control" required #accountId="ngModel"  (change)="getByVendorStatus(currentInventoryUpdateObj.accountId)" name="accountId"
                                        [(ngModel)]="currentInventoryUpdateObj.accountId"
                                        data-placeholder="Choose a Role Name" tabindex="1">
                                        <option disabled="" value="" selected>Account Id</option>

                                        <option *ngFor="let ual of userAccountsList" value="{{ual._id}}">
                                            {{ual.emailAddress}}</option>

                                    </select>
                                    <span class="text-danger" [hidden]="!accountId.errors.required"
                                        *ngIf="accountId.errors && (accountId.touched || accountId.dirty)">*Please
                                        select Account Id
                                    </span>
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Product
                                        Name </label>
                                    <input type="text" id="productName" class="form-control" required minlength="3"
                                        maxlength="30" #productName="ngModel" name="productName"
                                        [(ngModel)]="currentInventoryUpdateObj.productName" placeholder="Product Name"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!productName.errors.required"
                                        *ngIf="productName.errors && (productName.touched || productName.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!productName.errors?.pattern"
                                        *ngIf="productName.errors && (productName.touched || productName.dirty)">
                                        Product Name Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!productName.errors?.minlength || productName.errors.pattern"
                                        *ngIf="productName.errors && (productName.touched || productName.dirty)">Product
                                        Name Should Be Min 3 Characters</span>
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                       
                        <div class="row">
                            <div class="col-md-6 ">
                                <label class="control-label"> <span class="text-danger">*</span> Product
                                    Unique Number</label>
                                <div class="form-group">
                                    <input type="text" id="productUniqueNumber" required #productUniqueNumber="ngModel"
                                        name="productUniqueNumber"
                                        [(ngModel)]="currentInventoryUpdateObj.productUniqueNumber" class="form-control"
                                        rows="4">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!productUniqueNumber.errors.required"
                                        *ngIf="productUniqueNumber.errors && (productUniqueNumber.touched || productUniqueNumber.dirty)">
                                        This Field is Required</span>

                                </div>
                            </div>
                            <div class="col-md-6 ">
                                <label class="control-label"> <span class="text-danger">*</span> Product Status
                                   </label>
                                <div class="form-group">
                                    <!-- <select class="form-control" id="productStatus" required #productStatus="ngModel"
                                        name="productStatus" [(ngModel)]="currentInventoryUpdateObj.productStatus"
                                         tabindex="1"> -->
                                         <input lass="form-control" id="productStatus" required #productStatus="ngModel"
                                         name="productStatus" [(ngModel)]="currentInventoryUpdateObj.productStatus" class="form-control"
                                          tabindex="1">

                                        <!-- <option value="Expired">Expired</option>
                                        <option value="Consumed ">Consumed</option> -->
                                        <!-- <option value="Returned ">Returned </option> -->

                                  
                                    <span class="text-danger" [hidden]="!productStatus.errors.required"
                                        *ngIf="productStatus.errors && (productStatus.touched || productStatus.dirty)">*Please
                                        select Yes/No
                                    </span>

                                </div>
                            </div>
                        </div>
                        <label class="control-label"> <span class="text-danger">*</span> Product
                            Description</label>
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="form-group">
                                    <input type="text" id="description" required #description="ngModel"
                                        name="description" [(ngModel)]="currentInventoryUpdateObj.description"
                                        class="form-control" rows="4">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!description.errors.required"
                                        *ngIf="description.errors && (description.touched || description.dirty)">
                                        This Field is Required</span>

                                </div>
                            </div>
                        </div>
                        <!--/row-->
                        <div class="row">
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Stock
                                        Quantity
                                    </label>
                                    <input type="text" id="stockQuantity" class="form-control" required maxlength="30"
                                        #stockQuantity="ngModel" name="stockQuantity"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" required

                                        [(ngModel)]="currentInventoryUpdateObj.stockQuantity"
                                        placeholder="stockQuantity" maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!stockQuantity.errors.required"
                                        *ngIf="stockQuantity.errors && (stockQuantity.touched || stockQuantity.dirty)">
                                        *This Field is Required</span>


                                </div>
                            </div>
                            <!--/span-->
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Stock
                                        Unit
                                    </label>
                                    <input type="text" id="stockUnit" class="form-control" required minlength="3"
                                        maxlength="30" #stockUnit="ngModel" name="stockUnit"
                                        [(ngModel)]="currentInventoryUpdateObj.stockUnit" placeholder="Stock Unit"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!stockUnit.errors.required"
                                        *ngIf="stockUnit.errors && (stockUnit.touched || stockUnit.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Purchase
                                        Date
                                    </label>
                                    <input type="date" id="purchaseDate" class="form-control" required minlength="3"
                                        maxlength="30" #purchaseDate="ngModel" name="purchaseDate"
                                        [ngModel]="thePurchaseDate | date:'yyyy-MM-dd'"
                                        (ngModelChange)="thePurchaseDate = $event" placeholder="Select Date"
                                        maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!purchaseDate.errors.required"
                                        *ngIf="purchaseDate.errors && (purchaseDate.touched || purchaseDate.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Expiry
                                        Date
                                    </label>
                                    <input type="date" id="expiryDate" class="form-control" required minlength="3"
                                        maxlength="30" #expiryDate="ngModel" name="expiryDate"
                                        [ngModel]="theDate | date:'yyyy-MM-dd'" (ngModelChange)="theDate = $event"
                                        placeholder="Select Date" maxlength="40"
                                        [min]="currentInventoryUpdateObj.purchaseDate | date:'yyyy-MM-dd'">
                                    <!-- <input class="form-control field-control" [ngModel]="theDate | date:'yyyy-MM-dd'"
                                        (ngModelChange)="theDate = $event" type="date" name="theDate"> -->
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!expiryDate.errors.required"
                                        *ngIf="expiryDate.errors && (expiryDate.touched || expiryDate.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>

                            <!--/span-->
                        </div>
                        <!--/row-->
                        <!--/row-->
                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Storage
                                        Location
                                    </label>
                                    <input type="text" id="storageLocation" class="form-control" required minlength="3"
                                        maxlength="30" #storageLocation="ngModel" name="storageLocation"
                                        [(ngModel)]="currentInventoryUpdateObj.storageLocation"
                                        placeholder="Storage Location" maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!storageLocation.errors.required"
                                        *ngIf="storageLocation.errors && (storageLocation.touched || storageLocation.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Borrowed
                                    </label>
                                    <select class="form-control" id="borrowed" required #borrowed="ngModel"
                                        name="borrowed" [(ngModel)]="currentInventoryUpdateObj.borrowed"
                                        data-placeholder="Choose Yes/No" tabindex="1">
                                        <option value="yes ">YES</option>
                                        <option value="no ">NO </option>

                                    </select>
                                    <span class="text-danger" [hidden]="!borrowed.errors.required"
                                        *ngIf="borrowed.errors && (borrowed.touched || borrowed.dirty)">*Please
                                        select Yes/No
                                    </span>

                                </div>
                            </div>

                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Category Name</label>
                                    <select class="form-control"  #categoryId="ngModel"
                                        (change)="getSubCategoryByCategoryId(currentInventoryUpdateObj.category)"
                                        name="categoryId" [(ngModel)]="currentInventoryUpdateObj.category"
                                        data-placeholder="Choose a Role Name" tabindex="1">
                                        <option disabled="" value="" selected>Category</option>

                                        <option *ngFor="let cl of categoriesList" value="{{cl.name}}">
                                            {{cl.name}}</option>
                                            <option value="Others" >Others</option>
                                    </select>
                                    <span class="text-danger" [hidden]="!categoryId.errors.required"
                                        *ngIf="categoryId.errors && (categoryId.touched || categoryId.dirty)">*Please
                                        select Category
                                    </span>
                                    <br>

                                    <input type="text" id="otherCategory" required *ngIf="showTextField"
                                    #otherCategory="ngModel" name="otherCategory" placeholder="Enter category Name"
                                    [(ngModel)]="currentInventoryUpdateObj.otherCategory"
                                    class="form-control" rows="4">                                            </div>
                            </div>
                            <!--/span-->
                            <!--/span-->
                            
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Sub Category Name</label>
                                    <select class="form-control"  #subCategoryId="ngModel" (change)="checking(currentInventoryUpdateObj.subCategory)"
                                        name="subCategoryId" [(ngModel)]="currentInventoryUpdateObj.subCategory"
                                        data-placeholder="Choose a Sub Category" tabindex="1">
                                        <option disabled="" value="" selected>Sub Category</option>

                                        <option *ngFor="let scl of subCategoriesList" value="{{scl.name}}">
                                            {{scl.name}}</option>
                                            <option value="Others" >Others</option>

                                    </select>
                                    <span class="text-danger" [hidden]="!subCategoryId.errors.required"
                                        *ngIf="subCategoryId.errors && (subCategoryId.touched || subCategoryId.dirty)">*Please
                                        select Sub Category
                                    </span>
                                    <br>
                                    <input type="text" id="otherSubCategory" required *ngIf="showSubTextField"
                                    #otherSubCategory="ngModel" name="otherSubCategory" placeholder="Enter Sub Category Name"
                                    [(ngModel)]="currentInventoryUpdateObj.otherSubCategory"
                                    class="form-control" rows="4">
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Order ID

                                    </label>
                                    <input type="text" id="orderId" class="form-control"  minlength="3"
                                        maxlength="30" #orderId="ngModel" name="orderId"
                                        [(ngModel)]="currentInventoryUpdateObj.orderId" placeholder="Order Id"
                                        maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!orderId.errors.required"
                                        *ngIf="orderId.errors && (orderId.touched || orderId.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Vendor
                                        ID
                                    </label>
                                    <select class="form-control"  #vendorId="ngModel" name="vendorId"
                                        [(ngModel)]="currentInventoryUpdateObj.vendorId"
                                        data-placeholder="Choose a Vendor Name" tabindex="1">
                                        <option disabled="" value="" selected>Vendor</option>

                                        <option *ngFor="let vl of vendorsList" value="{{vl._id}}">
                                            {{vl.vendorName}}</option>

                                    </select>
                                    <span class="text-danger" [hidden]="!vendorId.errors.required"
                                        *ngIf="vendorId.errors && (vendorId.touched || vendorId.dirty)">*Please
                                        select vendorId
                                    </span>


                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Price</label>
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1"><i
                                                    class="ti-money"></i></span>
                                        </div>
                                        <input type="text" class="form-control" required #price="ngModel" name="price"
                                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
                                        [(ngModel)]="currentInventoryUpdateObj.price" placeholder="price"
                                            aria-label="price" aria-describedby="basic-addon1">
                                        <span class="text-danger" [hidden]="!price.errors.required"
                                            *ngIf="price.errors && (price.touched || price.dirty)">*This field is
                                            required
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <h5 class="card-title m-t-20">Profile
                                    Photo</h5>


                                <div class="btn btn-info waves-effect waves-light">
                                    <input type="file" id="container" accept="image/gif, image/jpeg, image/png"
                                        (change)="fileChangeUpdateEvent($event)" #productImage="ngModel"
                                        name="productImage" [(ngModel)]="currentInventoryUpdateObj.productImage"
                                        class="upload"> </div>
                                <span class="text-danger" [hidden]="!productImage.errors.required"
                                    *ngIf="productImage.errors && (productImage.touched || productImage.dirty)">*This
                                    Field is required
                                </span>
                            </div>
                            <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                style="margin: 3px;"> <br />
                        </div>

                    </div>

                    <div class="form-actions m-t-40">
                        <button type="submit" style="background-color: #353556;color:white" data-dismiss="modal"
                            class="btn" (click)="updateCurrentInventory()">
                            <i class="fa fa-check"></i> Update</button> &nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Cancel</button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<div id="responsiveUpdate" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Update Current Inventory Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #currentInventoryUpdate="ngForm" novalidate>
                    <div class="form-body">
                       
                       
                        <div class="row">
                           
                            <div class="col-md-6 ">
                                <label class="control-label"> <span class="text-danger">*</span> Product Status
                                   </label>
                                <div class="form-group">
                                    <select class="form-control" id="productStatus" required #productStatus="ngModel"
                                        name="productStatus" [(ngModel)]="currentInventoryUpdateObj.productStatus"
                                         tabindex="1">
                                         <!-- <input lass="form-control" id="productStatus" required #productStatus="ngModel"
                                         name="productStatus" [(ngModel)]="currentInventoryUpdateObj.productStatus" class="form-control"
                                          tabindex="1"> -->
                                          <option value="Available" disabled="" selected="">Available</option>

                                        <option value="Expired">Expired</option>
                                        <option value="Consumed ">Consumed</option> 
                                         <option value="Returned ">Returned </option>
                                         </select>

                                  
                                    <span class="text-danger" [hidden]="!productStatus.errors.required"
                                        *ngIf="productStatus.errors && (productStatus.touched || productStatus.dirty)">*Please
                                        Select Product Status
                                    </span>

                                </div>
                            </div>
                        </div>
                       
                      
                        <!--/row-->
                        <div class="row">
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>
                                      {{currentInventoryUpdateObj.productStatus}}  Quantity
                                    </label>
                                    <input type="text" id="stockQuantity" class="form-control" required maxlength="30"
                                        #stockQuantity="ngModel" name="stockQuantity"
                                        [(ngModel)]="currentInventoryUpdateObj.updatingQuantity"
                                        placeholder="stockQuantity" maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!stockQuantity.errors.required"
                                        *ngIf="stockQuantity.errors && (stockQuantity.touched || stockQuantity.dirty)">
                                        *This Field is Required</span>


                                </div>
                            </div>
                            <!--/span-->
                            <!--/span-->
                          
                        </div>
                        <!--/row-->
                        <div class="row">
                          
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>{{currentInventoryUpdateObj.productStatus}}
                                        Date
                                    </label>
                                    <input type="date" id="expiryDate" class="form-control" required minlength="3"
                                        maxlength="30" #expiryDate="ngModel" name="expiryDate"
                                        [ngModel]="theDate | date:'yyyy-MM-dd'" (ngModelChange)="theDate = $event"
                                        placeholder="Select Date" maxlength="40"
                                        [min]="currentInventoryUpdateObj.purchaseDate | date:'yyyy-MM-dd'">
                                    <!-- <input class="form-control field-control" [ngModel]="theDate | date:'yyyy-MM-dd'"
                                        (ngModelChange)="theDate = $event" type="date" name="theDate"> -->
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!expiryDate.errors.required"
                                        *ngIf="expiryDate.errors && (expiryDate.touched || expiryDate.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>

                            <!--/span-->
                        </div>
                        
                    </div>

                    <div class="form-actions m-t-40">
                        <button type="submit"  style="background-color: #353556;color:white" data-dismiss="modal"
                            class="btn" (click)="updateCurrentInventoryProductStatus()" [disabled]="currentInventoryUpdateObj.productStatus == 'Available'">
                            <i class="fa fa-check"></i> Update</button> &nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Cancel</button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div id="responsiveImages" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content" style="width:900px">
            <div class="modal-header">
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_0'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/productImages/'+productImageId+'_1'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_2'}}"
                width="100" height="100" />
            </div>
        </div>
    </div>
</div>
